import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

// core components
import quoteStyle from "assets/jss/material-kit-react/components/quoteStyle.jsx";

function Quote({ ...props }) {
  const {
    classes,
    className,
    children,
    plain,
    carousel,
    quote,
    ...rest } = props;
  const cardClasses = classNames({
    [classes.card]: true,
    [classes.cardPlain]: plain,
    [classes.cardCarousel]: carousel,
    [className]: className !== undefined
  });
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  return (
    <div className={classes.container} {...rest}>
      <GridContainer justify="space-around">
        <GridItem xs={12}>
          <Card raised className={cardClasses}>
            <CardHeader className={classNames(classes.cardHeader, classes.quotationMark)}>
                    &rdquo;
            </CardHeader>
            <CardBody className={classes.cardBody}>
              {
                !Array.isArray(quote.text) ?
                <span dangerouslySetInnerHTML={{__html: `${quote.text + '&nbsp;'}`}}></span> 
                : quote.text.map(chunk => {
                  return (
                    <span dangerouslySetInnerHTML={{__html: `${chunk + '&nbsp;'}`}}></span>
                  )
                })
              }
            </CardBody>
            <CardFooter>
              <GridContainer justify="space-around">
                <GridItem xs={12} className={classes.itemGrid}>
                <h4 className={classes.quoteAuthor}>
                  {quote.author.name}
                  <br />
                  <small dangerouslySetInnerHTML={{__html: quote.author.title}} className={classes.smallTitle}></small>
                </h4>
                </GridItem>
                {quote.img ? 
                <GridItem xs={4} className={classes.authorImageContainer}>
                  <img 
                  src={require(quote.img.src)}
                  alt={quote.img.alt} 
                  className={imageClasses} />
                </GridItem>
                : ""}
              </GridContainer>
            </CardFooter>
          </Card>
        </GridItem>
        {children}
      </GridContainer>
    </div>
  );
}

Quote.propTypes = {

};

export default withStyles(quoteStyle)(Quote);